<template>
  <PostboxList v-if="partnerProxyId" :partnerProxyId="partnerProxyId"></PostboxList>
</template>

<script setup lang="ts">
import PostboxList from '@/components/postbox/PostboxList.vue'
import { getPartnerProxyId } from '@/utils/KeycloakUtils'

const partnerProxyId = getPartnerProxyId()
</script>
